import { render, staticRenderFns } from "./StarterHeader2.vue?vue&type=template&id=04fdb64a&"
import script from "./StarterHeader2.vue?vue&type=script&lang=js&"
export * from "./StarterHeader2.vue?vue&type=script&lang=js&"
import style0 from "./StarterHeader2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports